<template>
  <mf-loading-dialog :loading="$apollo.queries.campaign.loading">
    <edit
      v-if="editable"
      :campaign.sync="campaign"
      :offer-schedule="offerSchedule"
      :is-offer-schedule-permission-active="isOfferSchedulePermissionActive"
      :is-offer-schedule-personalized="isOfferSchedulePersonalized"
    />
  </mf-loading-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_GET_EMAIL_CAMPAIGN_BY_ID } from '@/modules/campanhas/campanhas-email/graphql'
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import loadBenefitCampaignMixin from '@/modules/campanhas/cupom-desconto/mixins/load-benefit-campaign.js'

export default {
  name: 'EmailCampaign',
  components: {
    Edit: () => import('@/modules/campanhas/campanhas-email/views/pages/Edit.vue'),
  },
  mixins: [offerScheduleCampaign, loadBenefitCampaignMixin],
  data: () => ({
    campaignId: '',
    campaign: {
      title: '',
      description: '',
      products: [],
      segments: [],
      initial_date: '',
      final_date: '',
      status: 'DRAFT',
      template_id: '',
      message: {
        send_date: '',
        send_time: '',
        simple_email_configuration: {
          subject: '',
          header_image: null,
          text: '',
          image: null,
          click_to_call_button_text: '',
          click_to_call_button_link: '',
          footer: '',
        },
      },
      offers_schedule_id: '',
      frequency: {
        type: 'ONETIME',
        interval: 1,
      },
    },
  }),
  computed: {
    editable() {
      return ['DRAFT', 'SCHEDULED'].includes(this.campaign.status)
    },
  },
  apollo: {
    campaign: {
      query: QUERY_GET_EMAIL_CAMPAIGN_BY_ID,
      notifyOnNetworkStatusChange: true,
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
      update({ campaign }) {
        campaign.message.simple_email_configuration = campaign.message.simple_email_configuration || {}
        campaign.message.html_email_configuration = campaign.message.html_email_configuration || {}

        let newCampaign = cloneDeep(campaign)

        if (newCampaign && newCampaign.segments) {
          newCampaign.segments = newCampaign.segments.map((segment) => {
            segment.updating = false
            return segment
          })
        }

        if (newCampaign?.offers_schedule && Object.entries(newCampaign.offers_schedule).length) {
          newCampaign = { ...newCampaign, offers_schedule_id: newCampaign.offers_schedule._id }
          this.offerSchedule = newCampaign.offers_schedule
        } else {
          newCampaign = { ...newCampaign, offers_schedule_id: '' }
          this.offerSchedule = {}
        }

        delete newCampaign.offers_schedule

        return newCampaign || this.campaign
      },
      variables() {
        return {
          id: this.campaignId,
        }
      },
      skip() {
        if (!this.campaignId) return true
        return false
      },
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    $route(route) {
      if (route.params?.id?.length !== 24 && route.query?.quick_action) {
        // Reset the data
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
  },
  async mounted() {
    this.campaignId = this.$route.params.id
    if (this.campaignId?.length !== 24) this.campaignId = ''

    await this.loadBenefit({
      assignFieldsFn: ({ benefit, parsedSendDate, parsedFinalDate }) => {
        this.campaign.title = benefit.title
        this.campaign.description = benefit.description
        this.campaign.initial_date = parsedSendDate
        this.campaign.final_date = parsedFinalDate
        this.campaign.message.send_date = parsedSendDate

        this.campaign.segments = (benefit.segmentsData || []).map((s) => ({
          ...s,
          clients_qty: s.clientsQty,
          clients_refreshed_at: s.clientsRefreshedAt,
        }))
      },
    })
  },
}
</script>
